import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HomeIcon } from 'lucide-react';
export function ResidentialPickup() {
  return <div className="w-full min-h-screen bg-white" data-id="element-302">
      <Header data-id="element-303" />
      {/* Hero Section */}
      <section className="relative h-[400px] w-full" data-id="element-304">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vWZvkcsjmDam4QwceZjY3R/ResidentialPickup.jpg" alt="Residential Pickup" className="w-full h-full object-cover" style={{
        transform: 'rotate(-90deg) scale(1.5)',
        transformOrigin: 'center center'
      }} data-id="element-305" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/30" data-id="element-306"></div>
        <div className="absolute inset-0 flex items-center justify-center" data-id="element-307">
          <div className="text-center" data-id="element-308">
            <div className="w-20 h-20 bg-white rounded-lg flex items-center justify-center mx-auto mb-4" data-id="element-309">
              <HomeIcon className="w-10 h-10 text-[#E41C1C]" data-id="element-310" />
            </div>
            <h1 className="text-5xl font-bold text-white" data-id="element-311">
              Residential Pickup
            </h1>
          </div>
        </div>
      </section>
      {/* Content Section */}
      <section className="py-16 bg-white" data-id="element-312">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-313">
          <div className="space-y-6" data-id="element-314">
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-315">
              Our residential pickup service is the backbone of what we do.
              Every week, our experienced drivers navigate your neighborhood
              with care and precision, ensuring your waste is collected reliably
              and on schedule. We provide sturdy 96-gallon totes that can handle
              everything from everyday household trash to heavier items, giving
              you peace of mind that your waste management needs are covered.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-316">
              What sets Sam's Disposal apart is our commitment to personalized
              service. Unlike national chains that treat you like a number,
              we're your neighbors. Our drivers recognize your home, understand
              your needs, and are always willing to go the extra mile. Whether
              it's accommodating an occasional extra bag or working around your
              schedule, we're here to make waste removal as hassle-free as
              possible.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-317">
              With simple, transparent pricing and no hidden fees, you'll always
              know what you're paying for. We believe in honest business
              practices and building long-term relationships with our customers.
              When you choose Sam's Disposal for your residential pickup, you're
              not just getting trash service—you're supporting a local,
              family-owned business that's been serving the community since
              1989.
            </p>
          </div>
          {/* CTA Section */}
          <div className="mt-12 p-8 bg-gray-50 rounded-lg text-center" data-id="element-318">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-319">
              Ready to Get Started?
            </h3>
            <p className="text-gray-700 mb-6" data-id="element-320">
              Sign up for reliable weekly residential pickup service today.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-321">
              <a href="tel:231-796-2952" className="bg-[#E41C1C] text-white font-bold px-8 py-4 rounded hover:bg-red-700 transition-colors text-lg" data-id="element-322">
                Call (231) 796-2952
              </a>
              <button className="bg-white border-2 border-[#E41C1C] text-[#E41C1C] font-bold px-8 py-4 rounded hover:bg-gray-50 transition-colors text-lg" data-id="element-323">
                Request Service
              </button>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-324" />
    </div>;
}